import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { Tabs } from "antd";
import GeneralInfo from "../../components/company/GeneralInfo";
import CommercialInfo from "../../components/company/CommercialInfo";
import BankCard from "../../components/company/BankCard";

const CompanyPage = () => {
  const [companyData, setCompanyData] = useState([]);
  const apiUrl = process.env.REACT_APP_MONGO_URL;

  useEffect(() => {
    fetch(`${apiUrl}/api/companyProfile`)
      .then((res) => res.json())
      .then((data) => {
        setCompanyData(data);
      })
      .catch((error) => console.error(error));
  }, [apiUrl]);

  return (
    <Layout>
      <div className="pt-16 ml-64 p-4">
        <h1 className="text-2xl font-semibold mb-4">Firma Bilgileri</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <Tabs
            defaultActiveKey="1"
            type="card"
            items={[
              {
                key: "1",
                label: "Genel Bilgiler",
                children: <GeneralInfo companyData={companyData} apiUrl={apiUrl}/>,
              },
              {
                key: "2",
                label: "Ticari Bilgiler",
                children: <CommercialInfo  companyData={companyData} apiUrl={apiUrl}/>,
              },
              {
                key: "3",
                label: "Kart Bilgileri",
                children: <BankCard />,
              },
            ]}
          />
        </div>
      </div>
    </Layout>
  );
};

export default CompanyPage;
